import {
  DayPickerStrings,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'model'
import { DayOfWeek, IDropdownOption, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export type ProvingDetailsFlightFormValues = Proving

export class ProvingDetailsFlightFormSchema {
  constructor() {
    return Yup.object().shape({
      flight: Yup.object().shape({
        outboundData: Yup.object().shape({
          departure: Yup.date(),
        }),
        returnData: Yup.object().shape({
          departure: Yup.date(),
        }),
        bookingStatus: Yup.string(),
      }),
    })
  }
}

export interface ProvingDetailsFlightValues {
  flight: string
}

export const ProvingDetailsFlightForm: React.FunctionComponent<{
  notification?: boolean
  proving: Partial<Proving>
  wizardParticipants?: any
}> = ({ notification, proving, wizardParticipants }) => {
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = React.useState()

  let wizardParticipant
  if (wizardParticipants) {
    wizardParticipant =
      proving &&
      proving.participants &&
      proving.participants.find((x) => x._id === wizardParticipants[0])
  }

  const dateFromToUse = wizardParticipant
    ? wizardParticipant.dateFrom
    : proving.dateFrom
  const dateToToUse = wizardParticipant
    ? wizardParticipant.dateTo
    : proving.dateTo

  const options: IDropdownOption[] = [
    { key: 'roundtrip', text: t('dropdown.option.fOutwardAndReturn') },
    { key: 'outboundFlight', text: t('dropdown.option.fOutward') },
    { key: 'returnFlight', text: t('dropdown.option.fReturn') },
    { key: 'noFlight', text: t('dropdown.option.fNone') },
  ]

  return (
    <FormStack>
      {notification && (
        <FieldStack>
          <Label>
            {t(
              'Achtung! Es sind mehrere Einträge ausgewählt! Die Werte werden bei allen ausgewählten Einträgen mit den Werten aus der Formularmaske überschrieben!'
            )}
          </Label>
        </FieldStack>
      )}
      <FieldStack>
        <FieldStackItem
          name="flight.flightType"
          required={true}
          render={(fieldProps: FieldProps<ProvingDetailsFlightValues>) => {
            setSelectedItem(fieldProps.field.value)
            return (
              <FormikDropdown
                label={t('field.flight.label')}
                onChanged={(option: any) => {
                  setSelectedItem(option.key)
                  if (option.key === 'noFlight') {
                    fieldProps.form.setFieldValue(
                      'flight.outboundData',
                      undefined
                    )
                    fieldProps.form.setFieldValue(
                      'flight.returnData',
                      undefined
                    )
                  } else if (option.key === 'outboundFlight') {
                    fieldProps.form.setFieldValue(
                      'flight.outboundData.departure',
                      dateFromToUse
                    )
                    fieldProps.form.setFieldValue(
                      'flight.returnData',
                      undefined
                    )
                  } else if (option.key === 'returnFlight') {
                    fieldProps.form.setFieldValue(
                      'flight.returnData.departure',
                      dateToToUse
                    )
                    fieldProps.form.setFieldValue(
                      'flight.outboundData',
                      undefined
                    )
                  } else if (option.key === 'roundtrip') {
                    fieldProps.form.setFieldValue(
                      'flight.outboundData.departure',
                      dateFromToUse
                    )
                    fieldProps.form.setFieldValue(
                      'flight.returnData.departure',
                      dateToToUse
                    )
                  }
                }}
                {...fieldProps}
                options={options}
              />
            )
          }}
        />
      </FieldStack>
      <FieldStack horizontal={true}>
        {['roundtrip', 'outboundFlight'].includes(selectedItem) && (
          <FieldStackItem
            name="flight.outboundData.departure"
            label={t('field.dateFrom.label')}
            component={FormikGraphQLDatePicker}
            // minDate={new Date(proving.dateFrom)}
            // maxDate={new Date(proving.dateTo)}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            initialPickerDate={new Date(dateFromToUse)}
          />
        )}
        {['roundtrip', 'returnFlight'].includes(selectedItem) && (
          <FieldStackItem
            name="flight.returnData.departure"
            label={t('field.dateTo.label')}
            component={FormikGraphQLDatePicker}
            // minDate={new Date(proving.dateFrom)}
            // maxDate={new Date(proving.dateTo)}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            initialPickerDate={new Date(dateToToUse)}
          />
        )}
      </FieldStack>
    </FormStack>
  )
}
